module.exports = __webpack_public_path__ + "static/media/logo4.cef96b4c.png";